"use client";
import React from "react";
import NoResult from "@/components/errors/no-result";

export default function Error(error, reset) {

    return (
            <NoResult message = "خطایی در سایت رخ داده است. لطفا برای گزارش با ما تماس بگیرد." />

    )
}
